/**
 * DEV-258 — textos literais do Figma (specs/139…/figma-annotations.md).
 * O nó do frame fica ao lado de cada grupo para conferência.
 */

/** Onboarding — 20080:1214 (e variações 1238/1262/1286/1313/1337/1361). */
export const ONBOARDING = {
  title: 'Vamos criar uma vaga juntos',
  subtitleBefore:
    'Neste link, você encontra um formulário para dar mais detalhes sobre as vagas do ',
  subtitleAfter: ' para nossa equipe de consultoria.',
  nameLabel: 'Nome',
  namePlaceholder: 'Ex.: Maria Silva',
  emailLabel: 'E-mail',
  emailPlaceholder: 'Ex.: maria.silva@exemplo.com',
  tokenLabel: 'Token de acesso',
  tokenPlaceholder: 'Insira aqui seu token',
  paste: 'Colar',
  start: 'Começar',
  invalidEmail: 'Endereço de e-mail inválido',
  invalidToken: 'O token informado não é válido.',
  emptyFields: 'Preencha todos os campos para começar',
  invalidFields: 'Preencha os campos corretamente para começar',
} as const;

/**
 * Quando o aviso de tela pequena aparece (o Figma não fixa breakpoint):
 * toque em retrato OU largura < 1024px. Tablet deitado passa ("vire o seu
 * tablet"); celular em qualquer orientação não. `research.md` D17.
 */
export const ALIGNMENT_SMALL_SCREEN_QUERY =
  '(pointer: coarse) and (orientation: portrait), (max-width: 1023px)';

/** Tela pequena — 20089:4154 / 20012:3084. */
export const SMALL_SCREEN = {
  title: 'Parece que a sua tela é um pouco pequena.',
  body: 'Para usar a plataforma, acesse pelo computador ou vire o seu tablet',
} as const;

/** Sem conexão — 20186:22985. */
export const NO_CONNECTION = {
  title: 'Você está sem internet',
  body: 'Confira sua conexão e tente de novo.',
  retry: 'Tentar novamente',
} as const;

/** Erro grave ("404") — 20186:22986. */
export const GRAVE_ERROR = {
  title: 'Algo deu errado',
  body: 'Tente novamente em alguns instantes ou fale com quem te enviou esse link.',
  retry: 'Tentar novamente',
} as const;

/** Títulos do Sonner de erro (§4 da anotação, ≤ 35 caracteres). */
export const TOAST = {
  noConnection: 'Sem conexão. Tente de novo depois.',
  interrupted: 'O envio parou e nada foi salvo.',
  timeout: 'O envio demorou demais.',
  server: 'Algo deu errado. Tente novamente',
  maintenance: 'Estamos em manutenção.',
  tooManyAttempts: 'Muitas tentativas. Espere um pouco.',
  formChanged: 'O formulário foi atualizado.',
  close: 'Fechar',
} as const;

/**
 * Resumo com pendências (QA 08/10/2026, T056). Não existe no Figma: copy
 * proposta, precisa do de acordo do PO. O servidor continua sendo a autoridade
 * (422 `incomplete`); esta lista só evita o envio que sabidamente falharia.
 */
export const SUMMARY_PENDING = {
  title: 'Faltam respostas obrigatórias',
  body: 'Complete as etapas abaixo para enviar a descrição da vaga.',
  /** Nome distinto do "Editar" da seção: a lista aponta o que FALTA. */
  action: 'Completar',
} as const;

/** Sucesso — 20186:22984. */
export const SUCCESS = {
  title: 'Descrição de vagas enviada',
  paragraphs: [
    'A descrição da vaga que você criou foi enviada para nossa equipe.',
    'Agora é com nossa equipe de consultoria: as respostas vão ser refinadas e usadas para criar as vagas deste programa.',
  ],
  another: 'Enviar outra descrição',
} as const;
